/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import axios from 'axios';
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { connect } from 'react-redux';
import {setProducts, initQuote} from '../actions/quote'

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";

function Index(props) {
  const [tableData, setTableData] = useState([]);
  const main = useRef();

  useEffect(() => {
    props.initQuote()
    axios.get('/quotes/index').then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success")
        setTableData(res.data.data);
    })    
  },[]);

  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="lg" className="m-auto">
          <Row>
            <Col  md="12">
              <div className="mt-3">                
                <Button className="btn-icon btn-2 float-right" color="primary" type="button"  onClick={()=>props.history.push("/requests/add")}>
                  <span className="btn-inner--icon mr-2">
                    <i className="fa fa-plus" />
                  </span>
                  NEW QUOTE REQUEST
                </Button>
              </div>
              
              {/* {props.status == "all" && */}
                <div style={{marginTop:'65px', borderRadius:'5px', background:'white'}}>
                  <h5 className="p-3">Draft Quotes</h5>
                  <Table  striped >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Order Id</th>
                        <th>Created at</th>
                        <th>Edit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        tableData.map((row, index)=>{
                          if(!row.status)
                          return (
                            <tr>
                              <th scope="row">{index+1}</th>
                              <td>#{row['id']} - R{row['revision']}</td>
                              <td>{row['created_at']}</td>
                              <td style={{cursor:"pointer"}}><i className="fa fa-pencil" onClick={()=>props.history.push("/requests/edit/"+row['id'])}></i></td>
                            </tr>
                          )
                        })
                      }
                    </tbody>
                  </Table>
                </div>
              {/* } */}
              <div style={{marginTop:'65px', borderRadius:'5px', background:'white'}}>
                  <h5 className="p-3">Requested Quotes</h5>
                  <div style={{overflow:'auto'}}>
                    <Table  striped >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Order Id</th>
                          <th>Created at</th>
                          <th>Edit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          tableData.map((row, index)=>{
                            if(row.status && (row.status.includes("Requested")||row.status.includes("Pending")))
                            return (
                              <tr>
                                <th scope="row">{index+1}</th>
                                <td>#{row['id']} - R{row['revision']}</td>
                                <td>{row['updated_at']}</td>
                                <td style={{cursor:"pointer"}}><i className="fa fa-pencil" onClick={()=>props.history.push("/requests/edit/"+row['id'])}></i></td>
                              </tr>
                            )
                          })
                        }
                      </tbody>
                    </Table>
                  </div>
                </div>
                <div style={{marginTop:'65px', borderRadius:'5px', background:'white'}}>
                  <h5 className="p-3">Completed Quotes</h5>
                  <div style={{overflow:'auto'}}>
                    <Table  striped >
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Order Id</th>
                          <th>Created at</th>
                          <th>Edit</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          tableData.map((row, index)=>{
                            if((row.status && row.status.includes("Completed")))
                            return (
                              <tr>
                                <th scope="row">{index+1}</th>
                                <td>#{row['id']} - R{row['revision']}</td>
                                <td>{row['updated_at']}</td>
                                <td style={{cursor:"pointer"}}><i className="fa fa-pencil" onClick={()=>props.history.push("/requests/view/"+row['id'])}></i></td>
                              </tr>
                            )
                          })
                        }
                      </tbody>
                    </Table>
                  </div>
                </div>
            </Col>
          </Row>
        </Container>
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    initQuote:()=>dispatch(initQuote()),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
